import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/constants/site";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "How It Works", id: "how-it-works" },
  { label: "Experiences", id: "experiences" },
  { label: "Destinations", id: "destinations" },
  { label: "About Us", id: "about" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#0C0D0F]/80 border-b border-white/10 shadow-2xl" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button data-testid="nav-wordmark" onClick={() => go("home")} className="flex items-center gap-3 text-left">
          <img src="/logo.png" alt="Nivaan Experiences logo" className="h-9 w-9 rounded-full object-cover" />
          <span className="leading-none">
            <span className="font-serif text-2xl font-medium tracking-[0.35em] text-zinc-100">NIVAAN</span>
            <span className="mt-1 block text-[9px] font-mono uppercase tracking-[0.4em] text-gold">Experiences</span>
          </span>
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[11px] font-medium uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-plan-cta"
            onClick={() => go("plan")}
            className="rounded-full bg-gold px-6 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-gold-hover"
          >
            Plan My Journey
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="text-zinc-200 lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-white/10 bg-[#0C0D0F]/95 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-1 px-5 py-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="py-3 text-left text-xs font-medium uppercase tracking-[0.25em] text-zinc-300 hover:text-gold"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-plan-cta"
              onClick={() => go("plan")}
              className="mt-3 rounded-full bg-gold px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-obsidian"
            >
              Plan My Journey
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
